export const truncate = (sentence, noOfword) => {
    if(sentence?.length < noOfword) return sentence;
    else{
        const word = sentence?.split(" ")
        const truncateSentance = word?.slice(0, noOfword)?.join(" ")
        return truncateSentance
    }
 }